import { Component, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { Http, HttpModule } from "@angular/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
    DialogModule,
    DropdownModule,
    GalleriaModule,
    LightboxModule,
    OverlayPanelModule,
    TooltipModule
} from "primeng/primeng";
import { FileDropModule } from "ngx-file-drop";

import { NgAuthGuardService } from "../ng-shared/ng-services/ng-auth-guard.service";
import { NgSharedModule } from "../ng-shared/ng-shared.module";

import { NgWaitModule } from "../ng-shared/ng-components/ng-wait/ng-wait.module";

import { TCITenantRemoteServices } from "../ng-tenant/tci-tenant-remote-services";
import { TciTenantService } from "../ng-tenant/tci-tenant.service";
import { TciTenantModelService } from "../ng-tenant/tci-tenant.model";
import { NgUserService } from "../ng-shared/ng-services/ng-user.service";
import { NgMarketplaceV2ListingService } from "./ng-marketplace-v2-listing/ng-marketplace-v2-listing.service";
import { NgMarketplaceV2RatingsComponent } from "./ng-marketplace-v2-listing/ng-marketplace-v2-ratings/ng-marketplace-v2-ratings.component";
import { NgMarketplaceV2Component } from "./ng-marketplace-v2.component";
import { NgMarketplaceV2ListingComponent } from "./ng-marketplace-v2-listing/ng-marketplace-v2-listing.component";
import { NgMarketplaceV2RequestComponent } from "./ng-marketplace-v2-listing/ng-marketplace-v2-request/ng-marketplace-v2-request.component";
import { NgMarketplaceV2GetComponent } from "./ng-marketplace-v2-listing/ng-marketplace-v2-get/ng-marketplace-v2-get.component";
import { NgMarketplaceV2AccessRevokedComponent } from "./ng-marketplace-v2-listing/ng-marketplace-v2-access-revoked/ng-marketplace-v2-access-revoked.component";
import { NgMarketplaceV2Service } from "./ng-marketplace-v2.service";
import { NgMarketplaceV2EditorComponent } from "./ng-marketplace-v2-editor/ng-marketplace-v2-editor.component";
import { NgMarketplaceV2PreviewComponent } from "./ng-marketplace-v2-preview/ng-marketplace-v2-preview.component";
import { NgMarketplaceV2MiniPreviewComponent } from "./ng-marketplace-v2-mini-preview/ng-marketplace-v2-mini-preview.component";
import { NgMarketplaceV2MediaComponent } from "./ng-marketplace-v2-media/ng-marketplace-v2-media.component";
import { NgMarketplaceV2AccessComponent } from "./ng-marketplace-v2-access/ng-marketplace-v2-access.component";

import { NgMediaModule } from "../ng-shared/ng-components/ng-media/ng-media.module";
import { NgRatingsModule } from "../ng-shared/ng-components/ng-ratings/ng-ratings.module";
import { NgClickOutsideModule } from "../ng-shared/ng-directives/ng-click-outside/ng-click-outside.module";
import { NgMarketplaceV2RequestRejectedComponent } from "./ng-marketplace-v2-listing/ng-marketplace-v2-request-rejected/ng-marketplace-v2-request-rejected.component";
import { NgRatingsService } from "../ng-shared/ng-components/ng-ratings/ng-ratings.service";
import { NgMarketplaceV2RatingsService } from "./ng-marketplace-v2-listing/ng-marketplace-v2-ratings/ng-marketplace-v2-ratings.service";
import { NgMarketplaceV2GuardrailComponent } from "./ng-marketplace-v2-guardrail/ng-marketplace-v2-guardrail.component";
import {NgMarketplaceV2MiniComponent} from "./ng-marketplace-v2-mini.component";


/**
 * NgMarketplaceV2ServiceFactory
 * @param tenantRemoteServices
 * @param tenantSvc
 * @param tenantModelSvc
 * @param userSvc
 * @constructor
 */
export function NgMarketplaceV2ServiceFactory(
    tenantRemoteServices: TCITenantRemoteServices,
    tenantSvc: TciTenantService,
    tenantModelSvc: TciTenantModelService,
    userSvc: NgUserService,
    http: Http): NgMarketplaceV2Service {
    return NgMarketplaceV2Service.getInstance(tenantRemoteServices, tenantSvc, tenantModelSvc, userSvc, http);
}


export function NgMarketplaceV2ListingServiceFactory(
    userSvc: NgUserService,
    http: Http
): NgMarketplaceV2ListingService {
    return NgMarketplaceV2ListingService.getInstance(userSvc, http);
}

export function NgMarketplaceV2RatingsServiceFactory(
    ratingsService: NgRatingsService
): NgMarketplaceV2RatingsService {
    return NgMarketplaceV2RatingsService.getInstance(ratingsService);
}

@Component({
    selector: "ng-mk-dummy-component",
    template: ""
})
export class MarketplaceDummyComponent {
}

@NgModule({
    imports: [
        CommonModule,
        HttpModule,
        RouterModule.forChild([
            {
                path: "marketplace",
                component: NgMarketplaceV2Component,
                canActivate: [
                    NgAuthGuardService
                ],
                children: [
                    {
                        // listingId = marketplace listing id
                        path: ":listingId",
                        component: MarketplaceDummyComponent,
                        canActivate: [
                            NgAuthGuardService
                        ]
                    },
                    {
                        path: "minimarketplace",
                        component: NgMarketplaceV2MiniComponent,
                        canActivate: [
                            NgAuthGuardService
                        ],
                    },
                    {
                        path: "**",
                        redirectTo: ""
                    }
                ]
            }
        ]),
        ReactiveFormsModule,
        FormsModule,
        NgSharedModule,
        NgWaitModule,
        NgMediaModule,
        NgRatingsModule,
        FileDropModule,
        TooltipModule,
        DialogModule,
        DropdownModule,
        NgClickOutsideModule,
        OverlayPanelModule,
        GalleriaModule,
        LightboxModule
    ],
    declarations: [
        MarketplaceDummyComponent,
        NgMarketplaceV2MiniComponent,
        NgMarketplaceV2Component,
        NgMarketplaceV2ListingComponent,
        NgMarketplaceV2RatingsComponent,
        NgMarketplaceV2RequestComponent,
        NgMarketplaceV2RequestRejectedComponent,
        NgMarketplaceV2GetComponent,
        NgMarketplaceV2AccessRevokedComponent,
        NgMarketplaceV2EditorComponent,
        NgMarketplaceV2PreviewComponent,
        NgMarketplaceV2MiniPreviewComponent,
        NgMarketplaceV2MediaComponent,
        NgMarketplaceV2AccessComponent,
        NgMarketplaceV2GuardrailComponent
    ],
    providers: [
        {
            provide: NgMarketplaceV2Service,
            useFactory: NgMarketplaceV2ServiceFactory,
            deps: [
                TCITenantRemoteServices,
                TciTenantService,
                TciTenantModelService,
                NgUserService,
                Http
            ]
        },
        {
            provide: NgMarketplaceV2ListingService,
            useFactory: NgMarketplaceV2ListingServiceFactory,
            deps: [
                NgUserService,
                Http
            ]
        },
        {
            provide: NgMarketplaceV2RatingsService,
            useFactory: NgMarketplaceV2RatingsServiceFactory,
            deps: [
                NgRatingsService
            ]
        }
    ],
    exports: [
        NgMarketplaceV2MiniComponent,
        NgMarketplaceV2Component,
        NgMarketplaceV2ListingComponent,
        NgMarketplaceV2RatingsComponent,
        NgMarketplaceV2RequestComponent,
        NgMarketplaceV2RequestRejectedComponent,
        NgMarketplaceV2GetComponent,
        NgMarketplaceV2AccessRevokedComponent,
        NgMarketplaceV2EditorComponent,
        NgMarketplaceV2PreviewComponent,
        NgMarketplaceV2MiniPreviewComponent,
        NgMarketplaceV2MediaComponent,
        NgMarketplaceV2AccessComponent,
        NgMarketplaceV2GuardrailComponent
    ]
})
export class NgMarketplaceV2Module {
}
